import React from 'react';
import FifthSection from './FifthSection';
import FirstSection from './FirstSection';
import FourthSection from './FourthSection';
import Navbar from './Navbar';
import SecondSection from './SecondSection';
import ThirdSection from './ThirdSection';
import { useRef } from 'react';

const Homepage = () => {
  const featureRef = useRef();
  const contactRef = useRef();

  const featureScroll = () => {
    featureRef.current.scrollIntoView();
  };
  const contactScroll = () => {
    contactRef.current.scrollIntoView();
  };
  return (
    <div className="relative overflow-hidden">
      <img className="pentagon-1" src="images/topPentagon.png" alt="" />
      <Navbar featureScroll={featureScroll} contactScroll={contactScroll} />
      <FirstSection />
      <SecondSection featureRef={featureRef} />
      <ThirdSection />
      <FourthSection />
      <FifthSection contactRef={contactRef} featureScroll={featureScroll} />
    </div>
  );
};

export default Homepage;
